/**
 * @date: 2023-04-19
 * @author: Kevin Hsiau <khsiau@max.md>
 * @copy: (C) Copyright 2022 MaxMD Corporation, All Rights Reserved.
 */

import React from 'react';
import {Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis} from "recharts";
import {Box, Typography} from "@mui/material";

const formatLegend = {
    fhirCount: 'FHIR Count',
    csvCount: 'Address Count'
}

const CustomLegendForCurrentSyncBar = ({ payload }) => {

   return (
       <div style={{ display: 'flex', justifyContent: 'center', gap: 10 }}>
           {payload?.map((entry, index) => (
               <span key={index} style={{color: entry.color, display: 'flex', gap: 5, alignItems: 'center', justifyContent: 'center'}}>
                   <Box width={14} height={14} style={{ backgroundColor: entry.color }}/>
                   {formatLegend[entry.value]}
               </span>
           ))}
       </div>
   )
}

const CustomTooltipForCurrentSyncBar = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        const name = payload[0].payload.name;
        const csvCount = payload[0].payload.csvCount;
        const fhirCount = payload[0].payload.fhirCount;
        return (
            <div style={{
                backgroundColor: "white",
                padding: "5px 10px",
                borderRadius: "8px",
                boxSizing: "border-box",
                boxShadow: "0 1px 8px rgba(0,0,0,0.5"
            }}>
                <Box display={'flex'} flexDirection={'column'}>
                    <span style={{ fontSize: '16px'}}>{name}</span>
                    <span style={{color: payload[0].color}}>Fhir Count: {fhirCount}</span>
                    <span style={{color: payload[1].color}}>Address Count: {csvCount}</span>
                </Box>
            </div>
        );
    }
    return null;
};

export default function CurrentSyncBar(props) {
    const { data } = props;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <Typography fontWeight='bold' color={'#777'} marginBottom={3}>
                Top 3 HISPs Count Comparison FHIR Endpoints to Unique Addresses
            </Typography>
            <BarChart
                width={500}
                height={275}
                data={data}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip content={<CustomTooltipForCurrentSyncBar />}/>
                <Legend content={<CustomLegendForCurrentSyncBar />}/>
                <Bar dataKey="fhirCount" fill="#ff9800" />
                <Bar dataKey="csvCount" fill="rgb(255 99 34)"  />
            </BarChart>
        </div>
    )


}
